const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const DEFAULT_LOCAL_BACKEND_URL = 'http://localhost:8000';
const DEFAULT_PROD_BACKEND_URL = 'https://becryptoai-e6b701abbee4.herokuapp.com';

const normalizeUrl = (url) => (url || '').replace(/\/+$/, '');

const isLocalhost = () => {
  if (typeof window === 'undefined') return false;
  return LOCALHOST_HOSTNAMES.has(window.location.hostname);
};

const getConfiguredBackendUrls = () => {
  const localUrl = normalizeUrl(process.env.REACT_APP_BACKEND_URL_LOCAL || DEFAULT_LOCAL_BACKEND_URL);
  const prodUrl = normalizeUrl(process.env.REACT_APP_BACKEND_URL_PROD || DEFAULT_PROD_BACKEND_URL);
  return { localUrl, prodUrl };
};

const isRetriableStatus = (status) => status >= 500 || status === 429 || status === 408;

export const getBackendCandidates = () => {
  const { localUrl, prodUrl } = getConfiguredBackendUrls();
  const envPref = (process.env.REACT_APP_BACKEND_PREF || '').toLowerCase();
  const allowProdOnLocalhost = process.env.REACT_APP_ALLOW_PROD_ON_LOCALHOST === 'true';

  let effectivePref = envPref;
  const runningOnLocalhost = isLocalhost();

  if (!['local', 'prod'].includes(effectivePref)) {
    effectivePref = runningOnLocalhost ? 'local' : 'prod';
  }

  // Running locally should default to the local backend even if env is misconfigured.
  if (runningOnLocalhost && !allowProdOnLocalhost) {
    effectivePref = 'local';
  }

  const preferred = effectivePref === 'prod' ? prodUrl : localUrl;
  const fallback = effectivePref === 'prod' ? localUrl : prodUrl;

  if (preferred === fallback) return [preferred];
  return [preferred, fallback];
};

export const getPreferredBackendUrl = () => getBackendCandidates()[0];

export const fetchWithBackendFallback = async (path, options = {}) => {
  const candidates = getBackendCandidates();
  let lastError = null;

  for (let index = 0; index < candidates.length; index++) {
    const backendUrl = candidates[index];
    const url = `${backendUrl}${path}`;

    try {
      const response = await fetch(url, options);

      if (response.ok) {
        return { response, backendUrl };
      }

      if (!isRetriableStatus(response.status) || index === candidates.length - 1) {
        return { response, backendUrl };
      }

      lastError = new Error(`Backend request failed with status ${response.status}`);
    } catch (error) {
      lastError = error;
      if (index === candidates.length - 1) {
        throw error;
      }
    }
  }

  throw lastError || new Error('Failed to reach backend');
};
